import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import Dashboard from '@/components/dashboard'
import VerifyCode from '@/components/verify-code'
import ClientRegister from '@/components/client/client-register'
import ClientLogin from '@/components/client/client-login'
import ClientIndex from '@/components/client/client-index'
import ClientRepwd from '@/components/client/client-repwd'
import Page404 from '@/components/404'

import WxLogin from '@/components/wxfwh/wx-login'
import WxPlayGameIndex from '@/components/wxfwh/play-game/index'
import WxOrderList from '@/components/wxfwh/apply-invoice/wx-order-list'
import WxApplyInvoice from '@/components/wxfwh/apply-invoice/wx-apply-invoice'
import WxEditInvoiceInfo from '@/components/wxfwh/apply-invoice/wx-edit-invoice-info'
import WxInvoiceList from '@/components/wxfwh/apply-invoice/wx-invoice-list'

import WxSellOrderList from '@/components/wxfwh/sell-order/sell-order-list'

import SellOrder from '@/components/sell/order'
import SellOrderManage from '@/components/sell/order-manage'
import SellReportByDate from '@/components/sell/report-by-date'
import ApproveInfoManage from '@/components/approve-info/manage'
import ApproveInfoApply from '@/components/approve-info/apply'
import ApproveInfoDetail from '@/components/approve-info/detail'

import RequireOrder from '@/components/require/order'
import RequireOrderManage from '@/components/require/order-manage'
import SaleOrder from '@/components/sale/order'
import SaleOrderManage from '@/components/sale/order-manage'
import BindProduceUnQuality from '@/components/bind-produce/un-quality'
import BindProduceTrackBind from '@/components/bind-produce/track-bind'
import BindProduceOrderManage from '@/components/bind-produce/order-manage'
import ProduceOrderManage from '@/components/produce/order-manage'
import PurchaseOrderDetail from '@/components/purchase/order-detail'
import DeliveryIssued from '@/components/delivery/issued'
import DeliveryRequireIssued from '@/components/delivery/require-issued'
import DeliveryArrived from '@/components/delivery/arrived'
import DeliveryRequireArrived from '@/components/delivery/require-arrived'
import DeliveryReport from '@/components/delivery/report'
import DeliveryOrderList from '@/components/delivery/order-list'
import StockGoodsStorage from '@/components/stock/goods-storage'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    name: 'Index',
    redirect: '/sell/order'
  },
  /*
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: { title: '首页' }
    },
    {
      path: '/wx-order-list',
      name: 'WxOrderList',
      component: WxOrderList,
      meta: { title: '订单信息' }
    },
    {
      path: '/wx-apply-invoice',
      name: 'WxApplyInvoice',
      component: WxApplyInvoice,
      meta: { title: '发票申请' }
    },
    {
      path: '/wx-edit-invoice-info',
      name: 'WxEditInvoiceInfo',
      component: WxEditInvoiceInfo,
      meta: { title: '编辑抬头' }
    },
    {
      path: '/wx-invoice-list',
      name: 'WxInvoiceList',
      component: WxInvoiceList,
      meta: { title: '电子发票' }
    },
  */
  {
    path: '/wx-login',
    name: 'WxLogin',
    component: WxLogin,
    meta: { title: '微信绑定' }
  },
  {
    path: '/wx-sell-order-list',
    name: 'WxSellOrderList',
    component: WxSellOrderList,
    meta: { title: '订单信息' }
  },
  {
    path: '/wx-play',
    name: 'WxPlayGameIndex',
    component: WxPlayGameIndex,
    meta: { title: '大富翁游戏' }
  },
  {
    path: '/verify-code',
    name: 'VerifyCode',
    component: VerifyCode,
    meta: { title: '产品防伪追溯系统' }
  },
  {
    path: '/client-register',
    name: 'ClientRegister',
    component: ClientRegister,
    meta: { title: '供应商注册' }
  },
  {
    path: '/clogin',
    name: 'ClientLogin',
    component: ClientLogin,
    meta: { title: '供应商登录' }
  },
  {
    path: '/client-index',
    name: 'ClientIndex',
    component: ClientIndex,
    meta: { title: '供应商首页' }
  },
  {
    path: '/client-repwd',
    name: 'ClientRepwd',
    component: ClientRepwd,
    meta: { title: '供应商修改密码' }
  },
  {
    path: '/sell/order',
    name: 'SellOrder',
    component: SellOrder,
    meta: { title: '新增预订单' }
  },
  {
    path: '/sell/order-manage',
    name: 'SellOrderManage',
    component: SellOrderManage,
    meta: { title: '预订单管理' }
  },
  {
    path: '/require/order',
    name: 'RequireOrder',
    component: RequireOrder,
    meta: { title: '新增门店备货单' }
  },
  {
    path: '/require/order-manage',
    name: 'RequireOrderManage',
    component: RequireOrderManage,
    meta: { title: '门店备货单管理' }
  },
  {
    path: '/sale/order',
    name: 'SaleOrder',
    component: SaleOrder,
    meta: { title: '新增门店销售单' }
  },
  {
    path: '/sale/order-manage',
    name: 'SaleOrderManage',
    component: SaleOrderManage,
    meta: { title: '门店销售单管理' }
  },
  {
    path: '/bind-produce/un-quality',
    name: 'BindBindProduceUnQuality',
    component: BindProduceUnQuality,
    meta: { title: '产品质检' }
  },
  {
    path: '/bind-produce/track-bind',
    name: 'BindBindProduceTrackBind',
    component: BindProduceTrackBind,
    meta: { title: '产品绑定' }
  },
  {
    path: '/bind-produce/order-manage',
    name: 'BindBindProduceOrderManage',
    component: BindProduceOrderManage,
    meta: { title: '产品列表' }
  },
  {
    path: '/produce/order-manage',
    name: 'ProduceOrderManage',
    component: ProduceOrderManage,
    meta: { title: '生产单' }
  },
  {
    path: '/purchase/order-detail',
    name: 'PurchaseOrderDetail',
    component: PurchaseOrderDetail,
    meta: { title: '采购单详情' }
  },
  {
    path: '/delivery/issued',
    name: 'DeliveryIssued',
    component: DeliveryIssued,
    meta: { title: '订单送出' }
  },
  {
    path: '/delivery/require-issued',
    name: 'DeliveryRequireIssued',
    component: DeliveryRequireIssued,
    meta: { title: '门店订单送出' }
  },
  {
    path: '/delivery/arrived',
    name: 'DeliveryArrived',
    component: DeliveryArrived,
    meta: { title: '订单送达' }
  },
  {
    path: '/delivery/require-arrived',
    name: 'DeliveryRequireArrived',
    component: DeliveryRequireArrived,
    meta: { title: '门店订单送达' }
  },
  {
    path: '/delivery/report',
    name: 'DeliveryReport',
    component: DeliveryReport,
    meta: { title: '配送统计' }
  },
  {
    path: '/delivery/order-list',
    name: 'DeliveryOrderList',
    component: DeliveryOrderList,
    meta: { title: '待配送订单' }
  },
  {
    path: '/stock/goods-storage',
    name: 'StockGoodsStorage',
    component: StockGoodsStorage,
    meta: { title: '门店库存管理' }
  },
  {
    path: '/sell/report-by-date',
    name: 'SellReportByDate',
    component: SellReportByDate,
    meta: { title: '日销售情况' }
  },
  {
    path: '/approve-info/manage',
    name: 'ApproveInfoManage',
    component: ApproveInfoManage,
    meta: { title: '审批管理' }
  },
  {
    path: '/approve-info/apply',
    name: 'ApproveInfoApply',
    component: ApproveInfoApply,
    meta: { title: '审批申请' }
  },
  {
    path: '/approve-info/detail',
    name: 'ApproveInfoDetail',
    component: ApproveInfoDetail,
    meta: { title: '审批详情' }
  },
  {
    path: '/404',
    component: Page404
  }
]

// 需要通过菜单权限判断的路由
export const asyncRoutes = [
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
export default router



// WEBPACK FOOTER //
// ./src/router/index.js